
import * as React from 'react'
import { SystemGrid, DateCell, DateTimeCell, SystemPanel } from './../../../library'
import { GridColumn as Column, GridCellProps, GridRowClickEvent } from '@progress/kendo-react-grid'
import { DownloadFile } from '../../helpers/utils';

export default class AuditGrid extends React.Component<any, any, any>{

    DetailComponent = (props: any) => {

        const dataItem = props.dataItem;
        if (dataItem.AuditType != "Update") return null;
        return (
            <SystemGrid dataSource={"/Audit/FieldLevelAudit/" + (this.props.Schema) + '/' + this.props.Table + '/' + this.props.secondarySchema + '/' + this.props.secondaryTable + '/' + dataItem.ContextId} >
                <Column key={1} field="FieldName" title="Field Name" />
                <Column key={2} field="OldValue" title="Old Value" />
                <Column key={3} field="NewValue" title="New Value" />
            </SystemGrid>)
    }
    downloadTemplate = async () => {
      //  DownloadFile(config.apiEndpoint + `/Audit/DownloadAuditDump/` + this.props.Schema + '/' + this.props.Table + '/' + this.props.primaryKey + '/' + this.props.secondarySchema + '/' + this.props.secondaryTable + '/' + this.props.secondaryKey)
    }
    render() {
        return (
            <SystemPanel key="AudtiListPanel" label="System Audit" showArchive={false} showAdd={false} showRefresh={false}
                toolbar={[<button className="btn btn-primary btn-sm mr-1" title="Export to Excel" onClick={this.downloadTemplate}>Export to Excel</button>]} >
                <SystemGrid dataSource={"/Audit/GeneralAudit/" + this.props.Schema + '/' + this.props.Table + '/' + this.props.secondarySchema + '/' + this.props.secondaryTable + '/' + this.props.primaryKey + '/' + this.props.secondaryKey} detail={this.DetailComponent} expandField="expanded"
                >
                    <Column key={1} field="AuditType" title="Event Type" />
                    <Column key={2} field="SecurityUserName" title="User" />
                    <Column key={3} field="AuditDateTime" title="Date" cell={DateTimeCell} filter={"date"} />
                </SystemGrid>
            </SystemPanel>
        );
    }
}

//export default AuditGrid